import { toArray, shuffle } from '@/helpers/utils';

// we store the reference currently active component outside the reactive store
let activeTextpickerComponent = null;

export const Textpicker = {
    state: {},
    mutations: {},
    getters: {
        isTextpickerActive(state, getters, rootState) {
            if (rootState.route.query.textpicker) {
                return true;
            }
            return false;
        },
        getTexts(state, getters, rootState) {
            return rootState.tecpage.texts;
        },
        getRandomTextsInCurrentNamespace(state, getters, rootState) {
            let namespace = rootState.route.query.textpicker_namespace;
            if (namespace === undefined || namespace === null || namespace === '') {
                return [];
            }
            let texts = getters.getTexts;
            texts = toArray(getters.getTexts);
            texts = texts.filter((i) => {
                return namespace.includes(i.namespace);
            });
            texts = shuffle(texts);
            texts = texts.slice(0, 3);
            texts = texts.map((i) => {
                i.content = getters.applyTextVariables(i.content);
                return i;
            });
            return texts;
        },
        getRandomTextInNamespace(state, getters) {
            return (namespace) => {
                if (namespace === undefined || namespace === null || namespace === '') {
                    return [];
                }
                if (!Array.isArray(namespace)) {
                    namespace = namespace.split(',');
                }
                let texts = getters.getTexts;
                texts = toArray(texts);
                texts = texts.filter((i) => {
                    return namespace.includes(i.namespace);
                });
                if (texts.length === 0) {
                    throw 'error: text in namespace ' + namespace + ' not found!';
                }
                texts = shuffle(texts);
                return getters.applyTextVariables(texts[0].content);
            };
        },
        applyTextVariables(state, getters) {
            return (text) => {
                if (text) {
                    let regex, match, matches, shift;

                    // placeholders
                    let replacements = [
                        {
                            search: '<<FIRMENNAME>>',
                            replace: getters.getProp('deha.user.firma1')
                        },
                        {
                            search: '<<ORT>>',
                            replace: getters.getProp('deha.user.ort')
                        },
                        {
                            search: '<<GRUENDUNGSJAHR>>',
                            replace: getters.getProp('deha.user.gruendungsjahr')
                        },
                        {
                            search: '<<TEAMANZAHL>>',
                            replace: getters.getProp('deha.user.teamanzahl')
                        },
                        {
                            search: '<<ALTER>>',
                            replace: getters.getProp('deha.user.gruendungsjahr')
                                ? new Date().getFullYear() -
                                  parseInt(getters.getProp('deha.user.gruendungsjahr'))
                                : 'XXX'
                        }
                    ];
                    let company_name = getters.getProp('deha.user.firma1'),
                        company_forms = getters.getProp('Data.companyForms');
                    if (company_forms.some((i) => company_name.indexOf(i) > -1)) {
                        replacements.push({
                            search: '<<FIRMENNAME_PREFIX_1>>',
                            replace: 'der '
                        });
                        replacements.push({
                            search: '<<FIRMENNAME_PREFIX_2>>',
                            replace: 'Die '
                        });
                        replacements.push({
                            search: '<<FIRMENNAME_PREFIX_3>>',
                            replace: 'die '
                        });
                        replacements.push({
                            search: '<<FIRMENNAME_PREFIX_4>>',
                            replace: 'der '
                        });
                    } else {
                        replacements.push({
                            search: '<<FIRMENNAME_PREFIX_1>>',
                            replace: 'von '
                        });
                        replacements.push({
                            search: '<<FIRMENNAME_PREFIX_2>>',
                            replace: ''
                        });
                        replacements.push({
                            search: '<<FIRMENNAME_PREFIX_3>>',
                            replace: ''
                        });
                        replacements.push({
                            search: '<<FIRMENNAME_PREFIX_4>>',
                            replace: ''
                        });
                    }
                    replacements.forEach((replacements__value) => {
                        text = text.replace(
                            new RegExp(replacements__value.search, 'g'),
                            replacements__value.replace
                        );
                    });

                    // fill words
                    regex = /\(\((.+?)\)\)/g;
                    match = null;
                    matches = [];
                    shift = 0;
                    while ((match = regex.exec(text)) !== null) {
                        matches.push(match);
                    }
                    if (matches.length > 0) {
                        matches.forEach((matches__value) => {
                            let shift_pre = 0,
                                shift_post = 0;
                            if (
                                text.substring(
                                    matches__value.index + shift - 1,
                                    matches__value.index + shift
                                ) === ' '
                            ) {
                                shift_pre = 1;
                            }
                            if (
                                shift_pre === 0 &&
                                text.substring(
                                    matches__value.index + shift + matches__value[0].length,
                                    matches__value.index + shift + matches__value[0].length + 1
                                ) === ' '
                            ) {
                                shift_post = 1;
                            }
                            // delete
                            if (~~(Math.random() * (1 - 0 + 1)) + 0 === 1) {
                                text =
                                    text.substring(0, matches__value.index + shift - shift_pre) +
                                    text.substring(
                                        matches__value.index +
                                            shift +
                                            matches__value[0].length +
                                            shift_post
                                    );
                                shift -= shift_pre + shift_post + matches__value[0].length;
                            }
                            // keep
                            else {
                                text =
                                    text.substring(0, matches__value.index + shift) +
                                    matches__value[1] +
                                    text.substring(
                                        matches__value.index + shift + matches__value[0].length
                                    );
                                shift -= 4;
                            }
                        });
                    }

                    // variations
                    regex = /\{\{(.+?\/\/.+?)\}\}/g;
                    match = null;
                    matches = [];
                    shift = 0;
                    while ((match = regex.exec(text)) !== null) {
                        matches.push(match);
                    }
                    if (matches.length > 0) {
                        matches.forEach((matches__value) => {
                            let words = matches__value[1].split('//'),
                                word = words[Math.floor(Math.random() * words.length)];
                            text =
                                text.substring(0, matches__value.index + shift) +
                                word +
                                text.substring(
                                    matches__value.index + shift + matches__value[0].length
                                );
                            shift = shift - (matches__value[0].length - word.length);
                        });
                    }

                    return text;
                }
                return '';
            };
        }
    },
    actions: {
        async openTextpicker(context, { namespace, component }) {
            await context.dispatch('routeRemoveQuery', [
                'filemanager',
                'filemanager_source',
                'filemanager_accept',
                'filemanager_multiple',
                'fileeditor',
                'fileeditor_file_id'
            ]);
            await context.dispatch('routeAddQuery', {
                textpicker: 1,
                textpicker_namespace: Array.isArray(namespace) ? namespace.join(',') : namespace
            });
            // if another component was open
            if (activeTextpickerComponent !== null) {
                activeTextpickerComponent.textpickerIsOpen = false;
            }
            activeTextpickerComponent = component;
            activeTextpickerComponent.textpickerIsOpen = true;
        },
        async emitTextpicker(context, payload) {
            activeTextpickerComponent.setTextFromTextpicker(payload);
        },
        async closeTextpicker(context) {
            activeTextpickerComponent.textpickerIsOpen = false;
            activeTextpickerComponent = null;
            await context.dispatch('routeRemoveQuery', ['textpicker', 'textpicker_namespace']);
        }
    }
};
